/**
 * Status a MiG partition is shown with on the Infra page.
 *
 * `gpu_partitions.status` is a denormalised flag that can go stale: the
 * opportunity autosave used to delete and re-create `infra_assignments` rows
 * without resetting the partition it released, leaving partitions flagged
 * 'assigned' with no project behind them. The assignment row is the source of
 * truth (it is also what the project dropdown uses to hide taken partitions),
 * so the available/assigned pair is derived from it.
 *
 * Any other status (e.g. 'maintenance') is an explicit admin choice made in the
 * partition form, not a stale flag, so it is shown as is even when a project
 * still holds the partition.
 */
export const partitionDisplayStatus = (p: { status: string; assignment: unknown | null }): string => {
    if (p.status !== 'assigned' && p.status !== 'available') return p.status
    return p.assignment ? 'assigned' : 'available'
}
